import React from 'react'

import { innerContentStyles, outerSectionStyles } from './styles'
import { ContentWidths, ContentSectionProps } from './ContentSection.types'
import { Sentiment } from '@sidecar-components/types'

export const ContentSection: React.FC<ContentSectionProps> = ({
  children,
  // most folks' intuition will say that className should style
  // the inner content, even if they don't realize it's "inner content"
  className = '',
  // it's more rare that someone will need to style the wrapper so we
  // make that prop more unique and niche.
  wrapperClassName = '',
  testId = '',
  breathable = false,
  compact = false,
  sentiment = Sentiment.DEFAULT,
  strong = false,
  width = ContentWidths.DEFAULT,
  ...rest
}) => {
  // Rather than just displaying the children directly, we're going to
  // also pass down the sentiment of this section so that any child components
  // who are 'sentiment-enabled' can leverage this value without it needing to
  // be explictly set up.
  //
  // This only works for 1st level children so it may be better to use
  // React.Context, but I'm not sure yet.
  return (
    <section
      className={`${outerSectionStyles({
        breathable,
        compact,
        sentiment,
        strong,
      })} ${wrapperClassName}`}
      data-testid={testId}
      {...rest}
    >
      <div
        className={`${innerContentStyles({
          sentiment,
          strong,
          width,
        })} ${className}`}
      >
        {children}
      </div>
    </section>
  )
}
